export const isGuikerUser = (emailAddress?: string) => {
  const tokenized = emailAddress?.split('@')
  const isValidEmail = tokenized?.length === 2
  if (!isValidEmail) return false

  return tokenized[1] === 'guiker.com'
}
